// removed by extract-text-webpack-plugin
module.exports = {"Blog":"NewBook__Blog__3GhSO","textArea":"NewBook__textArea__C1Cmi","editordiv":"NewBook__editordiv__DvNWl","br_for_mobile":"NewBook__br_for_mobile__18MU7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewBook/NewBook.css
// module id = 476
// module chunks = 3